import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'y42-job-list-view[id]',
  templateUrl: './job-list-view.component.html',
  styleUrls: ['./job-list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobListViewComponent {
  @Input() id!: string;
}
